import { useTranslation } from 'react-i18next';
import type { TourDefinition } from '@klonup/design-system';

export function useWelcomeAdminTour(): TourDefinition {
  const { t } = useTranslation();
  return {
    id: 'welcome-admin',
    title: t('onboarding.welcome.menuTitle'),
    description: t('onboarding.welcome.menuDescription'),
    icon: '👋',
    // El paso 'intro' apunta al ancla data-tour="org-identity", que vive en el header
    // de OrgLayout y es visible en cualquier página de la organización. El resto de
    // pasos destacables apuntan a anclas data-tour="org-*" que solo existen en
    // MyOrganizationPage. OrgLayout navega a esta ruta antes de arrancar el tour.
    requiredPath: 'my-organization',
    steps: [
      {
        id: 'welcome',
        // Sin target → se renderiza como modal centrado de bienvenida.
        title: t('onboarding.welcome.steps.welcome.title'),
        description: t('onboarding.welcome.steps.welcome.description'),
      },
      {
        id: 'intro',
        target: '[data-tour="org-identity"]',
        title: t('onboarding.welcome.steps.intro.title'),
        description: t('onboarding.welcome.steps.intro.description'),
      },
      {
        id: 'usage',
        target: '[data-tour="org-usage"]',
        title: t('onboarding.welcome.steps.usage.title'),
        description: t('onboarding.welcome.steps.usage.description'),
      },
      {
        id: 'connections',
        target: '[data-tour="org-connections"]',
        title: t('onboarding.welcome.steps.connections.title'),
        description: t('onboarding.welcome.steps.connections.description'),
      },
      {
        id: 'users',
        target: '[data-tour="org-users"]',
        title: t('onboarding.welcome.steps.users.title'),
        description: t('onboarding.welcome.steps.users.description'),
      },
      {
        id: 'tutorials',
        target: '[data-tour="open-tutorials"]',
        title: t('onboarding.welcome.steps.tutorials.title'),
        description: t('onboarding.welcome.steps.tutorials.description'),
      },
    ],
  };
}
